import { create } from 'zustand'

interface ModalWelcomeWiggotState {
  isOpen: boolean
  setIsOpen: ({ isOpen }: { isOpen: boolean }) => void
}

const initialState = {
  isOpen: false
}

export const useModalWelcomeWiggotStore = create<ModalWelcomeWiggotState>()(
  (set) => ({
    ...initialState,
    setIsOpen: ({ isOpen }) => set({ isOpen })
  })
)
